import React from "react";
import chantAssetImage from "../../../../../images/chant-assets.png";
import ChantButton from "../../../../../CommonComponents/ChantButton/ChantButton";
import "./ChantAssets.css";

const ChantAssets = () => {
  return (
    <div className="chant-assets-container">
      <div id="chant-assets">
        <img src={chantAssetImage} style={{ width: "100%" }} alt="" />
      </div>
      <div className="chant-assets-description" style={{ color: "#000000" }}>
        <div className="chant-assets-description-content">
          <div style={{ display: "flex", flexWrap: "wrap" }}>
            <span style={{ fontSize: 18, fontWeight: "bold" }}>
              Chant Brand Assets
            </span>
          </div>
          <div>
            <p>
              Red, White and Black Chant logos (PNG and JPG) for digital
              promotion. Any use on physical product must be approved by Chant (
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="mailto:support@chant.fan"
              >
                support@chant.fan
              </a>
              )
            </p>
          </div>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          <ChantButton
            onClick={() => {
              // Using a direct path to the file in the public directory
              const zipPath = "/images/chant-assets.zip";

              fetch(zipPath)
                .then((response) => {
                  if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                  }
                  return response.blob();
                })
                .then((blob) => {
                  const url = window.URL.createObjectURL(
                    new Blob([blob], { type: "application/zip" })
                  );
                  const link = document.createElement("a");
                  link.href = url;
                  link.download = "Chant-Assets.zip";
                  document.body.appendChild(link);
                  link.click();
                  window.URL.revokeObjectURL(url);
                  document.body.removeChild(link);
                })
                .catch((error) => {
                  console.error("Error downloading zip file:", error);
                  alert(
                    "Failed to download the zip file. Please try again later."
                  );
                });
            }}
          >
            Download
          </ChantButton>
        </div>
      </div>
    </div>
  );
};

export default ChantAssets;
